module.exports = __webpack_public_path__ + "static/media/xiaomi_battery_5.0fa0b885.jpg";